import { render, staticRenderFns } from "./UploadDocumentModalComponent.vue?vue&type=template&id=50938638&"
import script from "./UploadDocumentModalComponent.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports